import { FavoriteEntry } from "../../store/favorite";
import { FC } from "react";
import { Trash2 as Trash2Icon } from "react-feather";
import { useNavigateTo } from "../../hooks/useNavigateTo";
import { TrackedQueryType } from "../../common/TrackedQueryType";

interface FavoriteListItemProps {
    favoriteEntry: FavoriteEntry;
    onDelete: (favoriteEntry: FavoriteEntry) => void;
}

const FavoriteListItem: FC<FavoriteListItemProps> = (props) => {
    const navigateTo = useNavigateTo();

    const { favoriteEntry, onDelete } = props;

    const navigateToAnswer = (favoriteEntry: FavoriteEntry) => {
        navigateTo("/answer", { query: favoriteEntry.answer.question, searchMethod: TrackedQueryType.Favorite, capturedSearchText: "N/A"});
    }

    return (
        <li>
            <a onClick={() => navigateToAnswer(favoriteEntry)}>{favoriteEntry.answer.question}</a>
            {<Trash2Icon className={"delete-icon"} onClick={() => onDelete(favoriteEntry)} />}
        </li>
    );
}

export default FavoriteListItem;